import { opaccAjaxPlugin } from '../opacc.static.js';
import { directSearchSuggestMessages } from '../messages/opacc.messages.js';

/** @module directsearchsuggest */

/**
 * Funktionalität zur Anzeige und Interaktion mit den asynchronen Suchergebnissen
 *
 */
export class OpaccDirectSearchSuggest {
    constructor() {
        this.replaceToActionUrl();

        this.searchTermAsUrlParam = true;
        this.navigationSectionSelector = '.section a';
        this.buttonOpen = document.querySelectorAll('.search-toggle');
        this.buttonClose = document.querySelectorAll('.search-head > .opc-button');
        this.wrapperElement = document.querySelectorAll('.opc-search');
        this.htmlDoc = document.querySelector('html');
        this.disallowedCharacter = '';

        this.attachEventListener();
    }

    /**
     *
     *
     */
    attachEventListener() {
        //search-toggle
        Array.from(this.buttonOpen).forEach((elem) => {
            elem.addEventListener('click', (e) => {
                if (e.target.classList.contains('mobile')) {
                    this.htmlDoc.classList.add('search-open');
                } else {
                    Array.from(this.wrapperElement).forEach((wrapper) => {
                        let searchType = false;
                        if (wrapper.dataset.opType) {
                            searchType = wrapper.dataset.opType;
                        }
                        if (!searchType === 'fullscreen') {
                            wrapper.classList.add('is-open');
                        }
                    });
                }
            });
        });
        Array.from(this.buttonClose).forEach((elem) => {
            elem.addEventListener('click', () => {
                this.htmlDoc.classList.remove('search-open');
            });
        });
        document.addEventListener('click', (e) => {
            if (e.target.closest('.opc-search') === null) {
                Array.from(this.wrapperElement).forEach((wrapper) => {
                    let searchType = undefined;
                    if (wrapper.dataset.opType) {
                        searchType = wrapper.dataset.opType;
                    }
                    if (!searchType === 'fullscreen') {
                        this.hideAsyncViewElement(wrapper);
                    }
                });
            }
        });

        Array.from(this.wrapperElement).forEach((wrapper) => {
            let directSearchForm = wrapper.querySelector('form');

            if (!directSearchForm) {
                return;
            }

            const directSearchInitFormAction = directSearchForm.action;
            let timer = 0;
            // close mobile overlay on click
            let mobileSearchOverlay = directSearchForm.querySelector(".opc-button[data-op-action='close']");
            if (mobileSearchOverlay) {
                mobileSearchOverlay.addEventListener('click', () => {
                    wrapper.classList.remove('is-open');
                });
            }

            // keyup on input-field
            let directSearchFormInput = directSearchForm.querySelector(
                '.opc-search-content > .opc-search-query > input',
            );

            if (directSearchFormInput) {
                directSearchFormInput.addEventListener('keyup', (e) => {
                    if (wrapper.dataset.opType && wrapper.dataset.opType == 'search-back') {
                        let btnSelectors = [
                            { selector: '.search-btn', type: 'add' },
                            { selector: '.reset-btn', type: 'remove' },
                        ];
                        this.toggleBtnState(wrapper, btnSelectors);
                    }

                    let input = e.currentTarget;
                    let asyncViewElement = wrapper.querySelector('.opc-search-results');
                    if (input instanceof HTMLInputElement && this.keyCodeAllowed(e.keyCode)) {
                        clearTimeout(timer);
                        timer = setTimeout(() => {
                            this.getSuggest(input, wrapper);
                        }, 500);
                        asyncViewElement.innerHTML = '';
                    } else if (e.keyCode === 27) {
                        //ESCAPE
                        this.hideAsyncViewElement(wrapper);
                    } else if (e.keyCode === 40) {
                        //DOWN
                        asyncViewElement
                            .querySelector(this.navigationSectionSelector)
                            .parentNode.firstElementChild.classList.add('focus')
                            .focus();
                    }
                });
            }

            if (wrapper.dataset.opType && wrapper.dataset.opType == 'search-back') {
                directSearchForm.querySelector('.reset-btn').addEventListener('click', (e) => {
                    let btnSelectors = [
                        { selector: '.search-btn', type: 'remove' },
                        { selector: '.reset-btn', type: 'add' },
                    ];
                    this.toggleBtnState(wrapper, btnSelectors);
                });

                directSearchForm.querySelector('.back-btn').addEventListener('click', (e) => {
                    if (this.htmlDoc.classList.contains('is-mobile')) {
                        this.hideAsyncViewElement(wrapper);
                        this.htmlDoc.classList.remove('search-open');
                    }

                    directSearchForm.querySelector('.reset-btn').click();
                });
            }
            //Submit search
            directSearchForm.addEventListener('submit', (e) => {
                let formInputElement = e.currentTarget.querySelector('.opc-search-content > .opc-search-query > input');

                let input = this.validateSearchInput(formInputElement);
                if (input.valid) {
                    let searchFilterAttrName = 'f-directsearchsuggest-filter-attribute';
                    let searchTermUrlParam = formInputElement.getAttribute('data-urlParam');
                    let filter = this.getFilter(formInputElement);

                    // remove previous hidden fields
                    let childFilterAttrElem =
                        directSearchForm.querySelector(`input[name="${searchFilterAttrName}"]`) || null;
                    if (childFilterAttrElem) {
                        directSearchForm.removeChild(childFilterAttrElem);
                    }
                    let childSearchTermElem =
                        directSearchForm.querySelector(`input[name="${searchTermUrlParam}"]`) || null;
                    if (childSearchTermElem) {
                        directSearchForm.removeChild(childSearchTermElem);
                    }

                    // add hidden-field to form
                    let hidden = document.createElement('input');
                    hidden.setAttribute('type', 'hidden');
                    hidden.setAttribute('name', searchFilterAttrName);
                    hidden.setAttribute('value', filter.attribute);
                    directSearchForm.appendChild(hidden);

                    let searchTerm = document.createElement('input');
                    searchTerm.setAttribute('type', 'hidden');
                    searchTerm.setAttribute('name', searchTermUrlParam);
                    searchTerm.setAttribute('value', input.value);

                    directSearchForm.appendChild(searchTerm);

                    if (this.searchTermAsUrlParam && searchTermUrlParam) {
                        let action = new URL(directSearchForm.action);
                        action.searchParams.set(`${searchTermUrlParam}`, `${input.value}`);

                        localStorage.setItem('searchActionUrl', action.toString()); // setzt temporär die Action URL in den Session Storage
                    }
                    return true;
                }
                e.preventDefault();
                return false;
            });

            document.addEventListener('click', (e) => {
                let suggestIsOpen = document.querySelector('.opc-search .opc-search-results.is-open');
                if (!suggestIsOpen) {
                    return;
                }

                if (
                    !e.target.closest('.opc-search .opc-search-results.is-open') &&
                    !e.target.closest('.dgnstcs-panel')
                ) {
                    this.toggleIsOpenCssClass(suggestIsOpen);
                }
            });

            // remove onsubmit Attribut to allow seach-submit
            directSearchForm.removeAttribute('onsubmit');
            // trigger keyup event if search-input was filled before script was loaded
            if (
                directSearchFormInput &&
                directSearchFormInput.value != '' &&
                directSearchFormInput.getAttribute('value') != directSearchFormInput.value
            ) {
                const customEvent = new Event('keyup');
                directSearchFormInput.dispatchEvent(customEvent);
            }
        });
    }

    /**
     *
     *
     * @param {*} elem
     */
    toggleIsOpenCssClass(elem) {
        elem.classList.toggle('is-open');
        elem.removeAttribute('style');
    }

    /**
     *
     *
     * @param {*} wrapper
     * @param {*} buttonSelectors
     */
    toggleBtnState(wrapper, buttonSelectors) {
        [...buttonSelectors].forEach((btn) => {
            let elem = wrapper.querySelector(btn.selector);
            if (!elem) {
                return;
            }
            elem.classList[btn.type]('is-hidden');
        });
    }

    /**
     *
     *
     * @param {*} elem
     * @returns {*}
     */
    getFilter(elem) {
        let filter = elem.parentNode.querySelector('.f-directsearchsuggest-filter');
        let filterObj = {
            object: undefined,
            value: undefined,
            attribute: undefined,
        };

        if (filter) {
            filterObj.object = filter;
            filterObj.value = filter.value;
            filterObj.attribute = filter.dataset.opDirectsearchsuggestFilterAttribute;
        }
        return filterObj;
    }

    /**
     *
     *
     * @param {*} elem
     * @returns {*}
     */
    validateSearchInput(elem) {
        let inputVal = elem.value.trim();
        let minLength = elem.dataset.opMinlength;
        let hasDangerousString = inputVal.includes('<');
        let hasDisallowedChars = this.hasDisallowedCharacters(inputVal);

        return {
            minimum: minLength,
            value: inputVal,
            valid: inputVal && minLength && inputVal.length >= minLength && !hasDangerousString && !hasDisallowedChars,
            hasDangerousString: hasDangerousString,
            hasDisallowedChars: hasDisallowedChars,
        };
    }

    /**
     *
     *
     * @param {*} inputVal
     * @returns {*}
     */
    hasDisallowedCharacters(inputVal) {
        if (inputVal == undefined || inputVal == '') {
            this.disallowedCharacter = '';
            return false;
        }

        let disallowedChars = "[^a-zA-Z0-9 äÄãÃåÅáÁàÀâÂéÉèÈêÊëËöÖóÓòÒôÔõÕüÜúÚùÙûÛìÌíÍîÎïÏñÑøØçÇß',-_\\.]+";
        if (
            window.opacc.systemDirectSearchSuggestDefaultSearchTermModifier &&
            window.opacc.systemDirectSearchSuggestDefaultSearchTermModifier.disallowedCharacters
        ) {
            disallowedChars = window.opacc.systemDirectSearchSuggestDefaultSearchTermModifier.disallowedCharacters;
        }

        let matches = inputVal.match(new RegExp(disallowedChars));
        if (matches) {
            if (matches.length > 0) {
                this.disallowedCharacter = matches[0];
                return true;
            }
        }

        this.disallowedCharacter = '';
        return false;
    }

    /**
     *
     *
     * @param {*} elem
     * @param {*} wrapper
     */
    getSuggest(elem, wrapper) {
        let input = this.validateSearchInput(elem);

        if (input.valid) {
            let filter = this.getFilter(elem);
            //prepare Data for async
            let data = {
                type: 'directsearchsuggest',
                inputValue: encodeURIComponent(input.value),
            };

            if (filter.attribute) {
                data.filterAttribute = filter.attribute;
            }
            if (filter.value) {
                data.filterValue = filter.value;
            }
            let url = opaccAjaxPlugin.setAsyncUrl();
            this.showAsnycViewElement(wrapper);
            opaccAjaxPlugin.fetchAsynPostForm(
                url,
                data,
                this.getDirectSearchSuggestDataFromResult.bind(this, wrapper),
                this.getDefaultErrorFnc,
                true,
            );
        } else if (elem.value.trim().length > 0) {
            let msgTextNode = document.createTextNode(
                directSearchSuggestMessages.messageTooShort.text.replace('%1', input.minimum),
            );

            if (input.hasDangerousString) {
                msgTextNode = document.createTextNode(directSearchSuggestMessages.messageDangerousString.text);
            }

            if (input.hasDisallowedChars) {
                msgTextNode = document.createTextNode(
                    directSearchSuggestMessages.messageDisallowedCharacter.text.replace('%1', this.disallowedCharacter),
                );
            }

            let msgElem = document.createElement('div');
            msgElem.setAttribute('class', 'opc-directsearch-message');
            msgElem.dataset.opType = 'info';
            msgElem.appendChild(msgTextNode);
            let asyncViewElement = wrapper.querySelector('.opc-search-results');
            asyncViewElement.insertAdjacentElement('afterbegin', msgElem);
            this.showAsnycViewElement(wrapper);
        } else {
            this.hideAsyncViewElement(wrapper);
        }
    }

    /**
     *
     *
     * @param {*} wrapper
     */
    showAsnycViewElement(wrapper) {
        let asyncViewElement = wrapper.querySelector('.opc-search-results');
        asyncViewElement.classList.add('is-open');
        asyncViewElement.style.display = 'block';
    }

    /**
     *
     *
     * @param {*} wrapper
     */
    hideAsyncViewElement(wrapper) {
        let asyncViewElement = wrapper.querySelector('.opc-search-results');
        if (asyncViewElement.classList.contains('is-open')) {
            asyncViewElement.classList.remove('is-open');
            asyncViewElement.style.display = 'none';

            let msgElem = asyncViewElement.querySelector('opc-directsearch-message');
            if (msgElem) {
                msgElem.remove();
            }
        }
    }

    /**
     *
     *
     * @param {*} wrapper
     * @param {*} response
     */
    getDirectSearchSuggestDataFromResult(wrapper, response) {
        let asyncViewElement = wrapper.querySelector('.opc-search-results');
        asyncViewElement.innerHTML = response.dataAsJson.html;
    }

    /**
     *
     *
     * @param {*} keyCode
     * @returns {*}
     */
    keyCodeAllowed(keyCode) {
        return (
            keyCode !== 13 && //ENTER
            keyCode !== 37 && //LEFT
            keyCode !== 39 && //RIGHT
            keyCode !== 38 && //UP
            keyCode !== 40 && //DOWN
            keyCode !== 27 //ESCAPE);
        );
    }

    /**
     * Methode ersetzt die "GET URL" zu der "POST ACTION URL" aus dem Session Storage,
     * damit die Paramter der URL wie die der "SearchTerm.URLParam" aus der application.cnf entsprechen.
     */
    replaceToActionUrl() {
        var actionUrl = localStorage.getItem('searchActionUrl')
            ? new URL(localStorage.getItem('searchActionUrl'))
            : null;

        if (actionUrl && actionUrl.pathname === window.location.pathname) {
            history.replaceState(null, 'searchActionUrl', actionUrl);
        }
        if (actionUrl) {
            localStorage.removeItem('searchActionUrl');
        }
    }
}
